<template>
    <main class="main">
        <div class="container">
            <div v-if="visible">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="page-header">
                            <span class="button-hollow" @click="back">{{ $t('button.back') }}</span>
                            <span :class="{ 'button-warn': true }" @click="remove">{{ $t('button.remove') }}</span>
                            <span :class="{ 'button-full': true, 'loading': loading }" @click="validate">{{ $t('button.save') }}</span>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-8">
                        <form class="form">
                          	<div class="row">
                                <div class="col-lg-4">
                                    <label>{{ $t('label.date') }}</label>
                                    <datepicker class="with-icon" v-model="appointment.date" :startYear="2015" :endYear="endYear"></datepicker>
                                </div>
                            	<div class="col-lg-4">
                              		<input-widget :min="0" type="number" :readonly="true" :label="$t('label.price') + ' (' + currency + ')'" v-model="appointment.price"></input-widget>
                            	</div>
                            	<div class="col-lg-4">
                             		<input-widget :min="0" type="number" v-model="appointment.total" :label="$t('label.total') + ' (' + currency + ')'"></input-widget>
                            	</div>
                          	</div>
                        	<div class="row">
                        		<div class="col-lg-12">
                        			<label>{{ $t('label.note') }}</label>
                            		<textarea v-model="appointment.note"></textarea>
                        		</div>
                        	</div>
                            <div class="row stretch">
                            	<div class="col-lg-6 col-md-12">
                            		<chooser-widget url="/v1/services/all" :label="$t('label.services')" v-model="services"></chooser-widget>
                            	</div>
                                <div class="col-lg-6 col-md-12">
                                    <chooser-widget url="/v1/materials/all" :label="$t('label.materials')" v-model="materials"></chooser-widget>
                                </div>
                            </div>
                            <div class="row">
                            	<div class="col-lg-12">
                            		<hr class="appointment-hr" />
                            	</div>
                            </div>
                            <div class="row">
                            	<div class="col-lg-6">
				                    <label class="appointment-label">{{ $t('label.created') }}</label>
				                    <div class="appointment-created">
					                    {{ appointment.created_at | formatDateTime }}
					                    <span v-if="appointment.created_by">
					                        ({{ appointment.created_by.first_name }} {{ appointment.created_by.last_name }})
					                    </span>
				                    </div>
                            	</div>
                            	<div class="col-lg-6">
				                    <label class="appointment-label">{{ $t('label.updated') }}</label>
				                    <div class="appointment-created">
					                    {{ appointment.updated_at | formatDateTime }}
					                    <span v-if="appointment.updated_by">
					                        ({{ appointment.updated_by.first_name }} {{ appointment.updated_by.last_name }})
					                    </span>
				                    </div>
                            	</div>
                            </div>
                        </form>
                    </div>
                    <div v-if="appointment.customer" class="col-lg-4">
                      	<div class="appointment-edit-customer">
                            <ul class="client-list">
                              <li>
                                <user-image :image="appointment.customer.image"></user-image>
                                <h3>{{ appointment.customer.name }}</h3>
                              </li>
                              <li v-if="appointment.customer.phone">
                                  <span aria-hidden="true" class="icon icon-phone"></span> <a :href="'tel:' + appointment.customer.phone">{{ appointment.customer.phone }}</a>
                              </li>
                              <li v-if="appointment.customer.email">
                                <span aria-hidden="true" class="icon icon-email"></span> {{ appointment.customer.email }}
                              </li>
                              <li v-if="appointment.customer.birthday">
                                <span aria-hidden="true" class="icon icon-calendar"></span> {{ appointment.customer.birthday | formatDate }}
                              </li>
                              <li v-if="appointment.customer.note">
                                <span aria-hidden="true" class="icon icon-list"></span> {{ appointment.customer.note }}
                              </li>
                            </ul>
                      	</div>
                        <customer-appointments ref="customerAppointments" :customer="appointment.customer" class="customerAppointments"></customer-appointments>
                    </div>
                    <div v-else class="col-lg-4">
                        <div class="customer-info">
                            <h4>
                                {{ $t('label.customerInfo') }}
                            </h4>
                            <div class="flex-left">
                                <user-image></user-image> {{ $t('label.noCustomer') }}
	                    	</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
  import auth from '@/auth'
  import ChooserWidget from '@/components/widgets/ChooserWidget'
  import InputWidget from '@/components/widgets/InputWidget'
  import Datepicker from '@/components/widgets/datepicker/VueDatepickerLocal'
  import CustomerAppointments from '@/components/pages/Organization/Customers/CustomerAppointments'
  import UserImage from '@/components/widgets/UserImageWidget'
  export default {
    name: 'EditAppointmentPage',
    components: {UserImage, CustomerAppointments, InputWidget, ChooserWidget, Datepicker},
    created () {
      this.load()
    },
    updated () {
      this.$nextTick(() => {
        this.init = false
      })
    },
    data () {
      return {
        visible: false,
        loading: false,
        appointment: null,
        currency: auth.getOrganization().currency.toUpperCase(),
        endYear: new Date().getFullYear() + 3,
        services: [],
        materials: [],
        init: true
      }
    },
    watch: {
      services () {
        if (!this.init) {
          let total = 0
          for (let i in this.services) {
            total = total + parseFloat(this.services[i].price)
          }
          for (let i in this.materials) {
            total = total + parseFloat(this.materials[i].price)
          }
          this.appointment.price = total
          this.appointment.total = total
        }
      },
      materials () {
        if (!this.init) {
          let total = 0
          for (let i in this.services) {
            total = total + parseFloat(this.services[i].price)
          }
          for (let i in this.materials) {
            total = total + parseFloat(this.materials[i].price)
          }
          this.appointment.price = total
          this.appointment.total = total
        }
      }
    },
    methods: {
      load () {
        this.$api.get('/v1/appointments/' + this.$route.params.appointment).then(response => {
          this.setAppointment(response.data.data)
          this.visible = true
        })
      },
      setAppointment (data) {
        this.appointment = data
        this.filterServices()
        this.materials = this.appointment.materials
      },
      validate () {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.save()
          }
        })
      },
      save () {
        this.loading = true
        if (typeof this.appointment.date === 'object') {
          this.appointment.date = this.$moment(this.appointment.date).format('YYYY-MM-DD')
        }
        this.appointment.services = this.services
        this.appointment.materials = this.materials
        this.$api.post('/v1/appointments/' + this.appointment.id, this.appointment).then(response => {
          this.init = true
          this.setAppointment(response.data.data)
          this.loading = false
          this.$events.fire('message-open', {
            type: 'success',
            message: this.$t('message.saveSuccess')
          })
        }).catch(error => {
          this.init = true
          this.loading = false
          if (error.response.data.error.code === 1004 && error.response.data.error.details.services) {
            this.$events.fire('message-open', {
              type: 'error',
              message: this.$t('message.noServices')
            })
          } else {
            this.$events.fire('message-open', {
              type: 'error',
              message: this.$t('message.saveFailed')
            })
          }
        })
      },
      remove () {
        let self = this
        this.$dialog.open({
          title: self.$t('message.areYouSure'),
          message: self.$t('message.removeAppointment'),
          okText: self.$t('button.remove'),
          cancelText: self.$t('button.cancel')
        }).then(response => {
          self.$api.delete('/v1/appointments/' + self.appointment.id).then(() => {
            self.back()
            self.$events.fire('appointment-deleted', {
              appointment: self.appointment
            })
            response.close()
          }).catch(error => {
            console.error(error)
            this.$events.fire('message-open', {
              type: 'error',
              message: self.$t('message.somethingWentWrong')
            })
          })
        }).catch(() => {})
      },
      back () {
        this.$router.go(-1)
      },
      filterServices () {
        let services = []
        for (let i in this.appointment.tasks) {
          services.push(this.appointment.tasks[i].service)
        }
        this.services = services
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/Organization/Table/EditAppointment.vue